import i18next from "i18next"
import { branding } from "../resources"
import { Link } from "react-router-dom"


export const topLogo =
    branding.textLogoOverride
        ?
        <Link to="/">
            <img src={branding.textLogo} alt={`${branding.brandName} ${branding.brandName2nd}`} className="max-w-[200px] max-h-[64px] py-2" />
        </Link>
        :

        <a href="/" className="flex items-center gap-x-2 lg:gap-x-3 xl:gap-x-4">
            <img src={branding.logoIcon} alt="logo" className="w-[25px] xl:w-[30px]" />

            <p className="uppercase text-[18px] xl:text-[20px]">
                <span className="dark:text-darkMode-primary mr-1 font-medium">{branding.brandName}</span> {branding.brandName2nd}
            </p>
        </a>


export const copyRight = <div className='dark:text-darkMode-mutedText text-right p-1 pb-2'>
    {!branding.isRebranded && <p className="text-[12px]">{String(i18next.t('copyright.copyright') ?? "Copyright")} {new Date().getFullYear()} © {branding.brandName}</p>}
</div>